import React from 'react';
import { useProfileMetrics } from '@/hooks/useProfileMetrics';
import theme from '@/constants/theme';
import { Emotion, getEmotionById } from '@/constants/emotions';

const colorMap: Record<string, string> = {
  GREAT: '#00DFA2',
  GOOD: '#7B80FF',
  NEUTRAL: '#FFA500',
  BAD: '#F86666',
  TERRIBLE: '#F25C54',
};

const labelMap: Record<string, string> = {
  GREAT: 'Excelente',
  GOOD: 'Bien',
  NEUTRAL: 'Neutral',
  BAD: 'Mal',
  TERRIBLE: 'Terrible',
};

interface FeelingStat {
  feeling: Emotion['id'];
  count: number;
  percentage: number;
}

const EmotionStats = () => {
  const { data, loading } = useProfileMetrics();

  if (loading || !data) return null;

  return (
    <div style={styles.container}>
      <p style={styles.title}>Total de registros diarios</p>
      <ul style={styles.statsContainer}>
        {data.feelingsStats.map((item: FeelingStat) => {
          const EmotionIcon = getEmotionById(item.feeling)?.Icon;
          return (
            <li style={styles.row} key={item.feeling}>
              <div style={styles.left}>
                {EmotionIcon && <EmotionIcon style={styles.dot} />}
                <p style={styles.label}>{labelMap[item.feeling]}</p>
              </div>
              <p style={styles.days}>{item.count} días</p>
              {/* <p style={styles.percent}>{item.percentage}%</p> */}
            </li>
          );
        })}
      </ul>
    </div>
  );
};

const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  title: {
    color: theme.colors.text.default,
  },
  statsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
  },
  row: {
    display: 'flex',
    alignItems: 'center',
    backgroundColor: theme.colors.background.secondary,
    padding: 12,
    borderRadius: 10,
    justifyContent: 'space-between',
  },
  left: {
    display: 'flex',
    alignItems: 'center',
    gap: 6,
    flex: 1.2,
  },
  dot: {
    width: 24,
    height: 24,
  },
  label: {
    color: theme.colors.text.caption,
  },
  days: {
    color: theme.colors.text.default,
    fontSize: 14,
    textAlign: 'center',
  },
  percent: {
    flex: 1,
    color: '#ccc',
    fontSize: 14,
    textAlign: 'right',
  },
};

export default EmotionStats;